import { Routes, Route } from "react-router"
import { lazy, Suspense, useEffect, useState } from "react"
import Box from "@mui/material/Box"
import TerritoryNotFound from "./pages/TerritoryNotFound"
import { Loader } from "./components/layout/Loader"

// Lazy load pages 
const TerritoriesPage = lazy(() => import("@/pages/Territories"))
const TerritoryPage = lazy(() => import("@/pages/Territory"))



export default function App() {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(false)
  }, [])
  
  return (
    <>
      {loading && <Loader visible />}
      <Suspense fallback={<Loader visible />}>
        <Box id="page">
          <Routes>
            <Route path="/" element={<TerritoriesPage />} />
            <Route path="/territorio/:id" element={<TerritoryPage />} />

            <Route path="*" element={<TerritoryNotFound />} />
          </Routes>
        </Box>
      </Suspense>
    </>
  )
}
